import { HierarchyCard } from '@yes.technology/react-toolkit'

import Activity from './Activity'
import EditStep from './EditStep/EditStep'
import styled from 'styled-components'
import { Step as TStep } from 'types/shared'
import { useReviewContext } from '../context'

interface ItemProps {
  children: React.ReactNode
}

export const Item = styled.div<ItemProps>`
  position: relative;

  h2 {
    width: calc(100% - 32px);
  }
`

interface StepProps {
  steps: TStep[]
  goToStep?: (step: number) => void
}

const notDisplayedTypes = [
  'safe_html',
  'interaction_review',
  'embedded_sitemodel'
]

const Step = ({ steps, goToStep }: StepProps) => {
  const { flatData, reviewActivity, displayedActivityModels } =
    useReviewContext()
  const activityModels = flatData?.activity_models || {}

  return (
    <>
      {steps &&
        steps.map((step, i) => {
          const stepIndex = i + 1

          let activityModelIds = step.activity_models.filter(
            (activityModelId) =>
              !(
                notDisplayedTypes.includes(
                  activityModels[activityModelId]?.content_type
                ) || activityModels[activityModelId]?.hide_in_review
              )
          )

          if (displayedActivityModels?.length) {
            activityModelIds = activityModelIds.filter((activityModelId) =>
              displayedActivityModels.includes(activityModelId)
            )
          }

          const hasSomeEmptyActivity = step.activity_models.some(
            (activityModelId) =>
              !flatData?.activity_models?.[activityModelId].informational &&
              !flatData?.activity_values?.[activityModelId]
          )

          const cardStatus = hasSomeEmptyActivity ? 'attention' : 'default'

          return activityModelIds.length ? (
            <Item key={step.uuid}>
              <HierarchyCard className='mt-2' status={cardStatus}>
                {!reviewActivity && (
                  <EditStep onClick={() => goToStep?.(stepIndex)} />
                )}
                <h2>{step.des}</h2>
                <div className='card-body'>
                  {step.complement && <p>{step.complement}</p>}

                  <Activity activityModelIds={activityModelIds} />
                </div>
              </HierarchyCard>
            </Item>
          ) : null
        })}
    </>
  )
}

export default Step
